import {
    START_LOADING,
    END_LOADING,
    FETCH_FEATURES,
    FETCH_FEATURE_BY_LANG,
    CREATE_FEATURE,
    UPDATE_FEATURE,
    DELETE_FEATURE,
    ERROR_FEATURE,
} from "../actions/constants";

const initialState = {
    loadingFeatures: false,
    features: [],
    featuresByLang: [],
    numberOfPages: 1,
    error: null,
};

const features = (state = initialState, action) => {
    switch (action.type) {
        case START_LOADING:
            return { ...state, loadingFeatures: true, error: null, };
        case END_LOADING:
            return { ...state, loadingFeatures: false };
        case FETCH_FEATURES:
            return {
                ...state,
                feature: action.payload.data,
                numberOfPages: action.payload.numberOfPages,
            };
        case FETCH_FEATURE_BY_LANG:
            return {
                ...state,
                featuresByLang: action.payload,
            };
        case CREATE_FEATURE:
            return {
                ...state,
                features: [...state.features, action.payload],
                feature: action.payload,
            };
        case UPDATE_FEATURE:
            return {
                ...state,
                features: state.features.map((feature) =>
                    feature._id === action.payload._id ? action.payload : feature
                ),
                feature:
                    state.feature && state.feature._id === action.payload._id
                        ? action.payload
                        : state.feature,
            };
        case DELETE_FEATURE:
            return {
                ...state,
                features: state.features.filter((feature) => feature._id !== action.payload),
                feature:
                    state.feature && state.feature._id === action.payload
                        ? null
                        : state.feature,
            };
        case ERROR_FEATURE:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default features;
